"use client";

import { createPath } from "@/service/routing/routing";
import { CardTools } from "@/components/common/card-tools/card-tools";

export const CalculatorCard = ({
  calculator,
  onClick,
  showCategory = false,
}: {
  calculator: CalculatorPreviewVM;
  onClick?: () => void;
  showCategory?: boolean;
}) => {
  return (
    <CardTools
      key={calculator.id}
      title={calculator.title}
      subtitle={calculator.subtitle}
      link={createPath("calculator.show", {
        categorySlug: calculator.category?.slug ?? "",
        slug: calculator.slug ?? "",
      })}
      categoryLink={createPath("calculator.category", {
        slug: calculator.category?.slug ?? "",
      })}
      categoryName={calculator.category?.name}
      categorySvgContent={calculator.category?.iconSvgContent}
      onClickCategory={() => {}}
      onClick={() => {}}
      showCategory={!calculator.category ? false : showCategory}
    />
  );
};
